import Container from '../../components/Container';
import React from 'react';
import styles from './styles';

function ReferralTerms({ }) {

    const returnTextChunks = () => {
        return (
            <React.Fragment>
                <h1>Referral Program Terms and Conditions</h1>
                <p><strong>Effective Date:</strong> April 15, 2026</p>
                <p>These Referral Program Terms and Conditions ("Referral Terms") govern your participation in the StreamFunds, Inc. ("Stream") Referral Program ("Program"). By participating in the Program, you agree to these Referral Terms, which form part of the terms and policies listed at <a href="https://www.getstreamapp.com/terms">https://www.getstreamapp.com/terms</a>. In the event of any conflict, these Referral Terms control with respect to the Program.</p>

                <section>
                    <h2>1. Eligibility</h2>
                    <p>The Program is available only to eligible Stream users located in the United States.</p>
                    <ul>
                        <li>To qualify as a referrer ("Referrer"), you must have an active Stream account in good standing, complete required actions such as a withdrawal, and have referral eligibility enabled.</li>
                        <li>To qualify as a referred user ("Referee"), you must register for a new Stream account using a valid referral code or link from an eligible Referrer. Existing or former Stream users are not eligible to receive rewards as Referees.</li>
                        <li>Stream reserves the right to determine or change eligibility for any user at any time, in its sole discretion, and to disqualify any participant for any reason, including suspected fraud, abuse, or violation of these terms.</li>
                    </ul>
                </section>

                <section>
                    <h2>2. How the Program Works</h2>
                    <ul>
                        <li>Eligible Referrers receive a unique referral code and link.</li>
                        <li>A Referee must create a new account using the Referrer's code or link, successfully connect their payroll account (or other approved method), and pass Stream's underwriting and eligibility review.</li>
                        <li>Stream may test different referral offer variants at any time. The specific rewards (if any) are determined solely by Stream.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Referral Rewards</h2>
                    <ul>
                        <li>Referrers and Referees may receive incentives such as cash bonuses, fee refunds, increased limits, or other benefits depending on the active offer variant.</li>
                        <li>All rewards are issued only after successful verification and are subject to Stream's review and approval.</li>
                        <li>Referral codes and links have no cash value, cannot be sold, transferred, or redeemed for cash, and are for personal use only.</li>
                        <li>Rewards are non-transferable and may be subject to taxes. You are solely responsible for any and all tax consequences arising from any rewards received.</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Limitations, Restrictions, and Disclaimers</h2>
                    <ul>
                        <li>Stream makes no guarantee that you will receive a referral code, that any referral will result in a reward, or that any specific type or amount of reward will be offered.</li>
                        <li>Stream may modify, suspend, limit, or terminate the Program, any offer variant, or any user's participation at any time, for any reason, with or without notice.</li>
                        <li>Rewards may be delayed, withheld, reversed, or clawed back if fraud, abuse, or a violation of these terms is discovered, even after initial payout.</li>
                        <li>The following are strictly prohibited and will result in disqualification, forfeiture of rewards, and possible account suspension or termination:
                        <ul>
                            <li>Self-referrals or referring yourself through multiple accounts</li>
                            <li>Creating fake or duplicate accounts</li>
                            <li>Using automated systems, scripts, or any form of manipulation</li>
                            <li>Sharing referral codes publicly in a manner that violates Stream's policies</li>
                            <li>Any other form of referral abuse</li>
                        </ul>
                        </li>
                        <li>Stream may impose additional limits (such as the maximum number of successful referrals per user) at any time.</li>
                    </ul>
                </section>

                <section>
                    <h2>5. General Provisions</h2>
                    <ul>
                        <li>These Referral Terms are governed by the laws of the State of Delaware, without regard to conflict of law principles.</li>
                        <li>Any disputes arising from the Program shall be resolved in accordance with the Dispute Resolution section of the Stream Terms of Service.</li>
                        <li>Stream may update these Referral Terms at any time. Your continued participation after changes constitutes acceptance of the updated terms.</li>
                        <li>If any provision is held invalid or unenforceable, the remaining provisions shall remain in full force and effect.</li>
                    </ul>
                    <p>By participating in the Stream Referral Program, you acknowledge that you have read, understood, and agree to be bound by these Referral Terms.</p>
                </section>
            </React.Fragment>
        );
    };

    return (
        <Container className={styles.background}>
            {returnTextChunks()}
        </Container>
    );
}

export default ReferralTerms;
